/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable jsx-a11y/no-redundant-roles */
import Head from 'next/head';
import React, { FC } from 'react';
import * as codeStyles from '../styles/code-samples';
import * as developerPortalStyles from '../styles/developerportal.styles';
import { NavigationPage } from '../lib/docs-api';
import * as typographyStyles from '../styles/typography';
import * as styles from './article.layout.styles';
import Breadcrumbs from './header/breadcrumbs';
import Navigation from './navigation';

// This layout is for displaying an article documentation page with left nav,  breadcrumbs and content.
interface ArticleLayoutProps {
  version: string;
  documentList: NavigationPage[];
  title: string;
  description: string;
}

const ArticleLayout: FC<ArticleLayoutProps> = ({
  version = 'latest',
  children,
  documentList,
  title = 'This is the default title',
  description = 'This is the default description',
}) => (
  <>
    <Head>
      <title>{title} | Domain Developer Portal</title>
      <meta name="description" content={description} />
      {/* <link rel="stylesheet" href="/assets/swagger-ui.css" /> */}
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/icon?family=Material+Icons&display=block"
      />
    </Head>
    <div css={developerPortalStyles.bodyGrid}>
      <div css={developerPortalStyles.bodyGridBreadcumbs}>
        <Breadcrumbs
          withBreadcrumbs
          baseUrl="/"
          documentList={documentList}
          version={version}
          isFullWidth
        />
      </div>
      <article css={developerPortalStyles.bodyGridContent} role="article">
        <a css={styles.navigationSkipLink} role="" href="#table-of-contents">
          Skip to Table of Contents
        </a>
        <div css={typographyStyles.typography}>
          <span css={codeStyles.codeExamples}>{children}</span>
        </div>
      </article>
      <div css={developerPortalStyles.bodyGridMenu}>
        <Navigation version={version} documentList={documentList} />
      </div>
    </div>
  </>
);

export default ArticleLayout;
